import styled from 'styled-components';

export const WarningAlert = styled.div`
  background-color: var(--cvna-color-yellow-1);
  border: 2px solid var(--cvna-color-yellow-2);
  text-align: center;
  border-radius: 5px;
  padding: 20px 10px;
  margin: 10px 0;
`;

